export const pathTemplating = (
	path: string,
	vars: Record<string, unknown> = {},
) => path.replace(/\{(\w+)\}/gm, (_, match) => `${vars[match] || ''}`)
